import React from 'react';
import styles from './ApplicatorsGrid.module.scss';
import { IoTrashOutline } from 'react-icons/io5';
import { FaEdit } from 'react-icons/fa';
import _ from 'lodash';
import moment from "moment";
import { $getLanguage, $t } from "../../helpers/translator";
import api from "../../helpers/api";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import ConfirmationBox from "../miscellaneous/ConfirmationBox/ConfirmationBox";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import DataTableGrid from "../miscellaneous/DataTableGrid/DataTableGrid";
import Input from "../miscellaneous/Input/Input";
import HasPermission from 'helpers/permissions/HasPermission';

class ApplicatorsGrid extends React.Component {
    static defaultProps = {
        userType: 2,
        clinicId: '',
        platformId: '',
        header: $t('global.applicators.applicators')
    }

    constructor(props) {
        super(props);

        this.state = {
            lang: $getLanguage(),
            userType: 2,

            applicators: [],

            pagination: null,
            payload: {
                sort: 'created_at',
                order: 'asc',   // or desc
                search: '',
                clinic: '',   // or id
                page: 1,
                per_page: 10,
                platformId: ''
            },
            tableLoading: false,

            sortingOptions: [
                {
                    label: $t('global.machines.serialNumber'),
                    value: 'handle_id'
                },
                {
                    label: $t('global.applicators.applicatorModelName'),
                    value: 'name'
                },
                {
                    label: $t('global.applicators.dateAdded'),
                    value: 'created_at'
                },
            ],
            selectedSortingOption: {
                label: $t('global.applicators.dateAdded'),
                value: 'created_at'
            },

            clinicOptions: [
                {
                    label: $t('global.applicators.allClinics'),
                    value: ''
                },
            ],
            selectedClinicOption: [
                {
                    label: $t('global.applicators.allClinics'),
                    value: ''
                },
            ],

            searchString: '',

            showDeleteApplicatorModalId: null,
            showEditApplicatorNameModal: null,
            applicatorNewSN: '',
            applicatorNewSNLoading: false,
            applicatorNewSNError: '',
            deleteApplicatorLoader: false,
        };
    }

    async componentDidMount() {
        let state = this.state;

        if (this.props.clinicId) {
            state.payload.clinic = this.props.clinicId;
        }

        if (this.props.perPage) {
            state.payload.per_page = this.props.perPage;
        }

        if (this.props.userType && this.props.userType !== 2) {
            state.userType = this.props.userType;
        }

        if (this.props.platformId) {
            state.payload.platformId = this.props.platformId;
        }

        this.setState(state, async () => {
            await this.getApplicators();
            await this.getClinics();
        })

    }

    async getApplicators() {
        this.setState({ tableLoading: true }, async () => {
            try {
                let payload = { ...this.state.payload };
                let res = await api.get(`/applicators?sort=${payload.sort}&order=${payload.order}&clinic=${payload.clinic}&platform_id=${payload.platformId}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}`);

                let pagination = null;
                let applicators = [];
                // console.log('APPLICATORS', res)
                if (res && res.data && res.data.success) {
                    _.forEach(res.data.data.data, (v, k) => {
                        applicators.push(this.renderApplicator(v));
                    });

                    pagination = res.data.data.pagination;
                }

                this.setState({
                    applicators: applicators,
                    pagination: pagination
                });

            } catch (e) {
                console.error('err get applicators:', e);
            } finally {
                this.setState({ tableLoading: false });
            }
        });
    }

    async getClinics() {
        if (this.state.userType === 2) {
            return;
        }
        try {
            let clinics = [ ...this.state.clinicOptions ];
            let res = await api.get('/general/clinics');

            if (res && res.data && res.data.success) {
                _.forEach(res.data.data, (v, k) => {
                    let clinic = {
                        label: v.name,
                        value: v.id,
                    }
                    clinics.push(clinic)
                })
                this.setState({ clinicOptions: clinics })
            }
        } catch (e) {
            console.error('err get clinics:', e);
        }
    }

    dataTableActionHandler(data) {
        if (data.key === 'page') {
            let payload = { ...this.state.payload };
            payload.page = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getApplicators();
            });
        }
    }

    renderApplicator(applicator) {
        return (
            <div className={ styles[ 'applicator-container' ] }>
                { this.props.userType === 5 && <HasPermission permission="applicators.delete">
                    <div className={ styles[ 'applicator-delete' ] }
                        onClick={ () => this.setState({ showDeleteApplicatorModalId: applicator }) }>
                        <Tooltip content={ $t('global.applicators.deleteApplicator') }>
                            <IoTrashOutline />
                        </Tooltip>
                    </div>
                </HasPermission> }
                <HasPermission permission="applicators.edit" else={ <>
                    <div className={ styles[ 'applicator-text-editable-name-text' ] }>
                        { applicator.serial_number ? applicator.serial_number : 'N/A' }
                    </div>
                </> }>
                    <Tooltip
                        content={ (applicator.serial_number ? $t('global.applicators.editApplicatorSN') : $t('global.applicators.addApplicatorSN')) }>
                        <div className={ styles[ 'applicator-text-editable-name' ] }
                            onClick={ () => {
                                this.setState({
                                    showEditApplicatorNameModal: applicator,
                                    applicatorNewSN: applicator.serial_number ? applicator.serial_number : ''
                                });
                            } }>
                            <div className={ styles[ 'applicator-text-editable-name-icon' ] }><FaEdit />
                            </div>
                            <div
                                className={ styles[ 'applicator-text-editable-name-text' ] }>{ applicator.serial_number ? applicator.serial_number : 'N/A' }</div>
                            <div className={ styles[ 'applicator-text-editable-name-icon' ] } style={ { visibility: 'hidden' } }>
                                <FaEdit />
                            </div>
                        </div>
                    </Tooltip>
                </HasPermission>
                <div className={ styles[ 'applicator-text-1' ] }>{ applicator.name }</div>
                <div className={ styles[ 'applicator-text-1' ] }>{ applicator.clinic_name }</div>
                <img className={ styles[ 'applicator-img' ] } src={ applicator.image } alt={ applicator.name } />
                <div className={ styles[ 'applicator-texts' ] }>
                    <div className={ styles[ 'applicator-text-2' ] }>{ applicator.handle_id }</div>
                    <div className={ styles[ 'applicator-text-3' ] }>{ applicator.pulses } { $t('global.applicators.pulses') }</div>
                </div>

                { applicator.created_at && moment(applicator.created_at).isValid() ?

                    <div className={ styles[ 'bottomPart' ] }>
                        <Tooltip
                            content={ moment(applicator.created_at).format('LLL') }>
                            Added { moment(applicator.created_at).fromNow() }
                        </Tooltip>
                    </div>

                    :
                    null
                }

            </div>
        );
    }

    async editApplicatorSerial() {
        let error = '';

        if (this.state.applicatorNewSN.length > 30) {
            error = $t('validation.general.maxLength', [ 30 ]);
        }
        if (this.state.applicatorNewSN.length < 8) {
            error = $t('validation.general.minLength', [ 8 ]);
        }
        if (!this.state.applicatorNewSN) {
            error = $t('validation.general.required');
        }

        let payload = {
            id: this.state.showEditApplicatorNameModal.id,
            serial_number: this.state.applicatorNewSN   //new serial number entered by user
        };

        this.setState({
            applicatorNewSNLoading: true,
            applicatorNewSNError: error
        }, async () => {
            try {
                if (this.state.applicatorNewSNError) {
                    return;
                }
                // let resOld = await api.updateHandle(payload);
                let res = await api.patch(`applicators/${payload.id}`, payload);

                // console.log('>res:', res);
                if (res.data.success) {
                    // console.log(this.state.applicators)
                    await this.getApplicators();
                    await this.closeModals();
                } else {
                    this.setState({ applicatorNewSNError: 'Error updating serial number' });
                }
            } catch (e) {
                console.error('err updating applicator serial', e);
            } finally {
                this.setState({ applicatorNewSNLoading: false });
            }
        });
    }

    renderEditApplicatorSN() {
        return (
            <div className={ styles[ 'edit-applicator-name-form' ] }>
                <div className={ styles[ 'applicator-name' ] }>{ $t('global.applicators.handleSN') }</div>
                <div className={ styles[ 'applicator-name-explained' ] }>{ $t('global.applicators.handleSnExplained') }</div>
                <input name="applicatorSerial"
                    className={ 'alma-input' }
                    // className={styles['input-f']}
                    type="text"
                    value={ this.state.applicatorNewSN }
                    placeholder={ $t('global.applicators.enterHandleSN') }
                    onChange={ (e) => this.fieldChangeHandler('applicatorSN', e) } />
                <div className={ styles[ 'error-text' ] }>{ this.state.newNameError }</div>

                <div className={ styles[ 'validation-err' ] }>
                    { this.state.applicatorNewSNError }
                </div>
            </div>
        );
    }

    fieldChangeHandler(name, data) {
        if (name === 'applicatorSN') {
            this.setState({
                applicatorNewSN: data.target.value,
                applicatorNewSNError: ''
            });
            return;
        }

        let payload = { ...this.state.payload };
        let selectedSortingOption = { ...this.state.selectedSortingOption };
        let selectedClinicOption = { ...this.state.selectedClinicOption };

        if (name === 'sort') {
            payload.sort = data.value;
            selectedSortingOption = data;
        }
        if (name === 'clinic') {
            payload.clinic = data.value;
            selectedClinicOption = data;
        }

        this.setState({
            payload: payload,
            selectedSortingOption: selectedSortingOption,
            selectedClinicOption: selectedClinicOption
        }, async () => {
            await this.getApplicators();
        });
    }

    nameSearchHandler(e) {
        let payload = { ...this.state.payload };
        payload.search = e.target.value;

        this.setState({ payload: payload }, async () => {
            await this.getApplicators();
        });
    }


    renderDeleteApplicatorConfirmation() {
        return (
            <div className={ styles[ 'delete-container' ] }>
                <div className={ styles[ 'delete-first-row' ] }>
                    { $t('global.applicators.confirmApplicatorDeletion') }
                </div>
                <div className={ styles[ 'delete-third-row' ] }>
                    { this.state.showDeleteApplicatorModalId ? this.state.showDeleteApplicatorModalId.handle_id : '' }
                </div>
                <div className={ styles[ 'delete-second-row' ] }>
                    { $t('global.applicators.deletionIsPermanent') }
                </div>
            </div>
        );
    }

    async deleteApplicator() {
        this.setState({
            deleteApplicatorLoader: true
        }, async () => {
            try {
                let response = await api.delete(`/applicators/${this.state.showDeleteApplicatorModalId.id}`);
            } catch (e) {
                console.error('delete applicator err', e);
            } finally {
                this.setState({
                    showDeleteApplicatorModalId: null,
                    deleteApplicatorLoader: false
                }, () => this.getApplicators());
            }
        })
    }

    closeModals() {
        this.setState({
            showDeleteApplicatorModalId: null,
            showEditApplicatorNameModal: null,
            applicatorNewSN: '',
            applicatorNewSNError: ''
        });
    }

    render() {
        let userType = this.state.userType;
        return (
            <div className={ styles[ 'container' ] }>
                <ConfirmationBox
                    visible={ this.state.showEditApplicatorNameModal }
                    content={ this.renderEditApplicatorSN() }
                    cancelButtonShow={ true }
                    cancelButtonText={ $t('global.general.confirm') }
                    cancelButtonAction={ async () => await this.editApplicatorSerial() }
                    onClose={ () => this.closeModals() }
                    loading={ this.state.applicatorNewSNLoading }
                />

                <ConfirmationBox
                    visible={ !!this.state.showDeleteApplicatorModalId }
                    content={ this.renderDeleteApplicatorConfirmation() }
                    confirmButtonShow={ true }
                    confirmButtonText={ $t('global.general.delete') }
                    confirmButtonAction={ () => this.deleteApplicator() }
                    onClose={ () => this.closeModals() }
                    loading={ this.state.deleteApplicatorLoader }
                />

                <div className={ styles[ 'box' ] }>
                    <div className={ 'alma-box' }>
                        <div className={ 'alma-box-header' }>
                            <div><h3>{ this.props.header }</h3></div>
                        </div>
                        <div className={ 'alma-fields-row' }>
                            { this.props.userType > 2 ?
                                <div className={ 'alma-field-container' }>
                                    <div className={ 'alma-field-header' }>{ $t('global.service.byClinic') }</div>

                                    <MultiSelect
                                        options={ this.state.clinicOptions }
                                        selected={ this.state.selectedClinicOption }
                                        onValueChange={ (data) => this.fieldChangeHandler('clinic', data) }
                                    />
                                </div>
                                :
                                null
                            }

                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.applicators.sortBy') }</div>

                                <MultiSelect
                                    options={ this.state.sortingOptions }
                                    selected={ this.state.selectedSortingOption }
                                    onValueChange={ (data) => this.fieldChangeHandler('sort', data) }
                                />

                            </div>

                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.applicators.searchApplicator') }</div>

                                <Input name="search"
                                    delay={ 500 }
                                    className={ 'alma-input' }
                                    type="text"
                                    value={ this.state.payload.search }
                                    placeholder={ $t('global.machines.serialNumber') }
                                    onChange={ (e) => this.nameSearchHandler(e) } />
                            </div>

                        </div>
                        <div>
                            <DataTableGrid data={ this.state.applicators }
                                pagination={ this.state.pagination }
                                loading={ this.state.tableLoading }
                                onAction={ (e) => this.dataTableActionHandler(e) }
                            />
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}


export default ApplicatorsGrid;


// let exampleApplicators = {
//     pagination: {
//         first_page: 1,
//         current_page: 2,
//         last_page: 4,
//
//         per_page: 10,
//         from: 11,
//         to: 20,
//         total: 37,
//     },
//     data: [
//         {
//             image: 'https://smart-clinic-pics.s3.eu-west-1.amazonaws.com/img/applicators/Quatro.png',
//             name: 'Trio 4cm',
//             id: 1176,
//             pulses: 323024,
//             handle_id: '2000000028B0AB37',
//             clinic_id: 1,
//             clinic_name: 'Mikiss clinic',         // !NEW!
//             serial_number: null
//         },
//         {
//
//             image: 'https://smart-clinic-pics.s3.eu-west-1.amazonaws.com/img/applicators/Quatro.png',
//             name: 'Trio 4cm'
//             id: 1447,
//             pulses: 568,
//             handle_id: '9C0000002869B637',
//             clinic_id: 1,
//             clinic_name: 'Mikiss clinic',         // !NEW!
//             serial_number: null
//         },
//         {
//             image: 'https://smart-clinic-pics.s3.eu-west-1.amazonaws.com/img/applicators/Compact.png',
//             name: 'Compact 1 cm',
//             id: 1999,
//             pulses: 123985,
//             handle_id: '3200000013AF2A37',
//             clinic_id: 1,
//             clinic_name: 'Mikiss clinic',         // !NEW!
//             serial_number: null
//         },
//         {
//             image: 'https://smart-clinic-pics.s3.eu-west-1.amazonaws.com/img/applicators/Trio.png',
//             name: 'Trio 2cm',
//             id: 1851,
//             pulses: 6574547,
//             handle_id: '7E000000241A4E37',
//             clinic_id: 1,
//             clinic_name: 'Mikiss clinic',         // !NEW!
//             serial_number: null
//         }
//     ]
// };
